import { useEffect, useRef, useState } from "react";

// Combobox : autocompletion filtrante + saisie libre autorisee.
export default function ComboBox({ value, onChange, options, placeholder, onBlur }) {
  const [ouvert, setOuvert] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const clicExterieur = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOuvert(false);
    };
    document.addEventListener("mousedown", clicExterieur);
    return () => document.removeEventListener("mousedown", clicExterieur);
  }, []);

  const saisie = (value || "").toLowerCase();
  const filtres = options
    .filter((o) => o.toLowerCase().includes(saisie))
    .slice(0, 8);

  return (
    <div className="combobox" ref={ref}>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(e) => {
          onChange(e.target.value);
          setOuvert(true);
        }}
        onFocus={() => setOuvert(true)}
        onBlur={onBlur}
      />
      {ouvert && filtres.length > 0 && (
        <ul className="combobox-liste">
          {filtres.map((o) => (
            <li
              key={o}
              className="combobox-option"
              onMouseDown={() => {
                onChange(o);
                setOuvert(false);
              }}
            >
              {o}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
